import React from 'react'
import queryString from 'query-string'
import { containerIds } from 'modules/ui'
import { STATUS } from 'modules/reservationFilter'
import { redirectTo } from 'frontend_core/dist/helpers/http'

export default class ReservationFilter extends React.Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.onSubmitReset = this.onSubmitReset.bind(this)
  }

  componentWillMount() {
    const { location, actions, data } = this.props
    const params = queryString.parse(location.search)
    const state = Object.assign({}, params, {
      status: params.status,
    })

    actions.setReservationFilter(state)
  }

  onChange(e) {
    const { actions } = this.props
    const input = e.target
    const state = {}

    state[input.name] = input.value
    actions.setReservationFilter(state)
  }

  onSubmitReset(e) {
    e.preventDefault()
    const { data } = this.props
    redirectTo(`/companies/${data.company.username}/reservations`)
  }

  render() {
    const { ui, data, reservationFilter } = this.props

    return (
      <form className="business-reservation__search" method="get">
        <p className="business-reservation__search-text">
          {i18n.t('page.shared.l_00024')}
        </p>
        <input
          type="text"
          name="id"
          placeholder="12345"
          className="business-reservation__search-form-id"
          value={reservationFilter.id}
          onChange={this.onChange}
        />
        <p className="business-reservation__search-text">
          {i18n.t('page.shared.l_00025')}
        </p>
        <input
          type="text"
          name="startedAt"
          placeholder="20171201"
          className="business-reservation__search-form-date"
          value={reservationFilter.startedAt}
          onChange={this.onChange}
        />
        <p className="business-reservation__search-period">〜</p>
        <input
          type="text"
          name="endedAt"
          placeholder="20171231"
          className="business-reservation__search-form-date"
          value={reservationFilter.endedAt}
          onChange={this.onChange}
        />
        <p className="business-reservation__search-text">
          {i18n.t('page.shared.l_00026')}
        </p>
        <label className="business-reservation__search-select">
          <select
            name="status"
            className="business-reservation__search-form-status"
            value={reservationFilter.status}
            onChange={this.onChange}
          >
            <option value="">{i18n.t('page.reservation_list.l_00001')}</option>
            <option value={STATUS.PAID}>{i18n.t('page.shared.l_00022')}</option>
            <option value={STATUS.UNPAID}>
              {i18n.t('page.shared.l_00023')}
            </option>
          </select>
        </label>
        <input
          type="submit"
          value={i18n.t('page.shared.l_00027')}
          className="button-green business-reservation__search-select-button ml10"
        />
        <input
          type="submit"
          value={i18n.t('page.shared.l_00028')}
          className="button-gray business-reservation__search-select-button ml5"
          onClick={this.onSubmitReset}
        />
      </form>
    )
  }
}
